
import moment from "moment";
export class PortalTransformer {
  static transform(obj) {
    return {
      id: obj.id,
      subdomain: obj.attributes.subdomain,
      long_name: obj.attributes.long_name,
      short_name: obj.attributes.short_name,
      color: obj.attributes.color,
      b_or_w: obj.attributes.b_or_w,
      logo_path: obj.attributes.logo_path,
      archived_at: obj.attributes.archived_at,
      logo: obj.attributes.logo,
      registration: obj.attributes.registration,
    };
  }
}



// WEBPACK FOOTER //
// ./src/helpers/portals/portal.transformer.js